<script setup lang="ts">
import type { Addresses } from '@Types';

defineProps<{
  address: Addresses;
}>();
</script>

<template>
  <div>
    <p class="overflow-hidden text-ellipsis">
      {{
        (address.address_1 || address.address1 || '') +
        ((address.address_1 || address.address1) && (address.address_2 || address.address2) ? ', ' : '') +
        (address.address_2 || address.address2 || '')
      }}
    </p>

    <p class="overflow-hidden text-ellipsis">
      {{ (address.state && address.city) || (address.zip && address.city) ? address.city + ', ' : address.city }}
      {{ address.state && address.zip ? address.state + ', ' : address.state }}
      {{ address.zip }}
      {{ address.country ? '- ' + address.country : '' }}
    </p>
  </div>
</template>
